import React from 'react';
import clsx from 'clsx';
import CheckCircle from "../../../../icons/CheckCircle";
import colors from "../../../../utils/colors";
import { createStyles } from "./styles";







var TitleWithSelectedIcon = function TitleWithSelectedIcon(_ref)



{var title = _ref.title,showIcon = _ref.showIcon,isCartItemSelected = _ref.isCartItemSelected;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("h2", { className: clsx(classes.name, showIcon && classes.portfolioName) }, /*#__PURE__*/

    React.createElement("div", { dangerouslySetInnerHTML: { __html: title } }),
    isCartItemSelected && showIcon && /*#__PURE__*/
    React.createElement(CheckCircle, { width: "3.2rem", color: colors.blue[600], className: classes.checkedIcon })));



};

export default TitleWithSelectedIcon;
//# sourceMappingURL=index.js.map